import { Box, Typography, DialogContent } from '@mui/material';
import React, { ReactElement, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks/hooks';
import {
    clearSite,
    createNewEmptySite,
    saveSite,
    selectClient,
    selectProject,
} from '../../../redux/actions/siteActions';
import { RootState } from '../../../redux/reducers';
import SiteFormStep from '../../sites/Form/SiteForm/SiteFormStep';
import { SaveEntityStatus } from '../../../redux/reducers/common';
import { GoogleMapsFormContainerBox } from '../../../common/ResponsiveStyle';

import { FormActions, FormDialogTitle } from '../../../common/components/form/FormPrimitives';

import { ResponsiveDialog } from '../../../common/components/mobile/MobilePrimitives';

type AddSiteToProjectFormProps = {
    open: boolean;
    closeForm(): void;
    projectId?: number;
};

export default function AddSiteToProjectForm(props: AddSiteToProjectFormProps): ReactElement {
    const { open, closeForm, projectId } = props;

    const site = useAppSelector((state: RootState) => state.site.site);
    const client = useAppSelector((state: RootState) => state.clientDetails.client);
    const saveStatus = useAppSelector((state: RootState) => state.site.saveStatus);
    const projects = useAppSelector((state: RootState) => state.clientDetails.projects);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (open) {
            if (!!projectId) {
                dispatch(selectProject(projectId));
            }
        }
    }, [projectId, open]);

    useEffect(() => {
        if (open) {
            if (!!client && !!client.id && client.id > 0) {
                dispatch(selectClient(client.id));
            }
        }
    }, [client, open]);

    useEffect(() => {
        if (open) {
            if (!site) {
                dispatch(createNewEmptySite());
            }
        }
    }, [site, open]);

    useEffect(() => {
        if (saveStatus === SaveEntityStatus.Saved) {
            handleClose();
        }
    }, [dispatch, saveStatus]);

    const submit = () => {
        dispatch(saveSite());
    };

    const isSiteValid =
        !!site &&
        !!site?.name &&
        site.name !== '' &&
        !!site.locationInfo &&
        site.locationInfo !== '' &&
        !!site.siteType;

    const handleClose = () => {
        dispatch(clearSite());
        closeForm();
    };

    return (
        <ResponsiveDialog maxWidth="lg" scroll="body" open={open} onClose={handleClose}>
            <FormDialogTitle>
                Projekat - {projectId ? projects!.find((p) => p.id === projectId)!.name : ''}
            </FormDialogTitle>
            <DialogContent dividers>
                <GoogleMapsFormContainerBox>
                    <Box sx={{ mb: 5 }}>
                        <Typography variant="h5" color="primary">
                            Skladište
                        </Typography>
                        <hr />

                        <SiteFormStep chooseType />
                    </Box>
                    <FormActions
                        onCancel={handleClose}
                        onSubmit={submit}
                        submitLabel="Sačuvaj"
                        disabled={!isSiteValid || saveStatus === SaveEntityStatus.Pending}
                        pending={saveStatus === SaveEntityStatus.Pending}
                        inGrid={false}
                    />
                </GoogleMapsFormContainerBox>
            </DialogContent>
        </ResponsiveDialog>
    );
}
